export interface ReflectionPhoneResInterface {
  repeat: number
  msg: string
}

export class ReflectionPhoneRes implements ReflectionPhoneResInterface {
  repeat: number
  msg: string

  constructor(props: ReflectionPhoneResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      repeat: _repeat,
      msg: _msg,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.repeat = _repeat
    this.msg = _msg
  }
}
